import * as React from 'react';

const StripePaymentRebrandingSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 192 128" fill="none" {...props}>
        <g clipPath="url(#stripe-payment-rebranding_svg__clip0_101_992)">
            <path
                d="M0 16C0 7.163 7.163 0 16 0h160c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V16z"
                fill="#fff"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M176 4H16C9.373 4 4 9.373 4 16v96c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V16c0-6.627-5.373-12-12-12zM16 0C7.163 0 0 7.163 0 16v96c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16V16c0-8.837-7.163-16-16-16H16z"
                fill="#E8E8E7"
            />
            <path
                d="M102.272 41.076l-10.566 2.268v-8.567l10.566-2.226v8.525zM59.334 37.422l-10.271 2.184-.042 33.632c0 6.214 4.672 10.79 10.902 10.79 3.452 0 5.978-.63 7.367-1.385v-8.524c-1.347.546-7.998 2.478-7.998-3.737V55.477h7.998v-8.944h-7.998l.042-9.11z"
                fill="#635BFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M171.771 65.05c0-10.75-5.22-19.23-15.196-19.23-10.019 0-16.08 8.48-16.08 19.146 0 12.638 7.156 19.02 17.427 19.02 5.009 0 8.798-1.134 11.66-2.73V72.86c-2.862 1.428-6.146 2.31-10.313 2.31-4.083 0-7.703-1.428-8.166-6.383h20.584c0-.231.015-.757.033-1.362v-.004c.023-.823.051-1.79.051-2.37zm-20.795-3.989c0-4.745 2.904-6.719 5.556-6.719 2.568 0 5.304 1.974 5.304 6.72h-10.86z"
                fill="#635BFF"
            />
            <path
                d="M34.457 54.931c-2.231 0-3.578.63-3.578 2.268 0 1.788 2.318 2.574 5.194 3.55 4.689 1.59 10.86 3.684 10.886 11.44 0 7.515-6.02 11.84-14.775 11.84-3.62 0-7.577-.714-11.492-2.394v-9.993c3.536 1.932 7.998 3.36 11.492 3.36 2.357 0 4.04-.63 4.04-2.562 0-1.98-2.512-2.886-5.546-3.978-4.62-1.665-10.45-3.764-10.45-10.76 0-7.431 5.683-11.882 14.229-11.882 3.494 0 6.946.546 10.44 1.931v9.867c-3.2-1.721-7.24-2.687-10.44-2.687zM80.383 49.64l-.674-3.107h-9.092v36.74H81.14v-24.9c2.484-3.232 6.694-2.645 7.999-2.183v-9.657c-1.347-.504-6.273-1.427-8.756 3.107zM91.705 46.534h10.566v36.739H91.705v-36.74z"
                fill="#635BFF"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M115.994 49.094c1.474-1.343 4.126-3.275 8.251-3.275 7.367 0 14.312 6.634 14.354 18.81 0 13.31-6.861 19.357-14.396 19.357-3.705 0-5.936-1.554-7.451-2.645l-.042 11.882-10.524 2.226V46.49h9.261l.547 2.603zm.758 23.683c1.01 1.092 2.484 1.974 4.967 1.974 3.873 0 6.483-4.2 6.483-9.826 0-5.501-2.652-9.785-6.483-9.785-2.399 0-3.914.84-5.009 2.058l.042 15.58z"
                fill="#635BFF"
            />
        </g>
        <defs>
            <clipPath id="stripe-payment-rebranding_svg__clip0_101_992">
                <path fill="#fff" d="M0 0h192v128H0z" />
            </clipPath>
        </defs>
    </svg>
);

StripePaymentRebrandingSvg.displayName = 'StripePaymentRebrandingSvg';
export default StripePaymentRebrandingSvg;
